<template>
  <div
    v-if="show"
    class="center-in-parent">
    <weex-image
      :src="refreshImageSrc"
      :style="refreshImageStyle"
      class="horizontal_center item-cursor"
      @click="onRefreshClicked"
      ></weex-image>
    <div v-if="refreshText">
      <weex-text :style="refreshTextStyle">{{refreshText}}</weex-text>
    </div>
  </div>
</template>

<script>
  import { ImageResourcesUtil } from "../../utils/ImageResourcesUtil";

  export default {
    components: {},
    props: {
      emitRefresh: {
        type: Boolean,
        default: true
      },
      show: {
        type: Boolean,
        default: false,
        required: true
      },
      refreshImageStyle: {
        type: Object,
        default: function () {
          return { "width": "60px", "height": "60px" }
        }
      },
      refreshText: {
        type: String,
        default: ""
      },
      refreshTextStyle: {
        type: Object,
        default: function () {
          return {
            "color": "black",
            "text-align": "center",
            "font-size": "14px",
            "max-width": "300px",
            "font-weight": "bold"
          }
        }
      }
    },
    methods: {
      onRefreshClicked() {
        if (this.emitRefresh) {
          this.$emit("onRefresh");
        }
      }
    },
    computed: {
      refreshImageSrc() {
        return ImageResourcesUtil.getImageLink(ImageResourcesUtil.REFRESH_BLUE)
      }
    }
  };
</script>

<style
  scoped
  src="../../assets/style/base.css"></style>
